import type { PersonaScriptDto } from "@/features/persona-opportunities/api/persona-opportunity-scripts.api";

/** Public preview URL — token is the script's own id, same as Opportunities. */
export function buildPersonaScriptShareUrl(scriptId: string, origin: string): string {
  return `${origin}/s/${scriptId}`;
}

/** Plain-text script dump for clipboard — same shape as the Opportunities copy. */
export function formatPersonaScriptForCopy(
  script: PersonaScriptDto,
  untitled: string,
): string {
  const lines: string[] = [];
  const title = script.hook?.trim() || untitled;
  lines.push(title);
  lines.push("");

  if (script.adDescription?.trim()) {
    lines.push(script.adDescription.trim());
    lines.push("");
  }

  const sequence =
    script.scenes.length > 0
      ? script.scenes.map((scene) => scene.sceneName).join(" → ")
      : script.sequence?.trim() || null;
  if (sequence) lines.push(`Sequence: ${sequence}`);
  if (script.concept?.trim()) lines.push(`Concept: ${script.concept.trim()}`);
  if (script.duration?.trim()) lines.push(`Duration: ${script.duration.trim()}`);
  if (script.presenter?.trim()) lines.push(`Presenter: ${script.presenter.trim()}`);
  if (script.background?.trim()) lines.push(`Background: ${script.background.trim()}`);
  if (script.product?.trim()) lines.push(`Product: ${script.product.trim()}`);
  if (
    sequence ||
    script.concept?.trim() ||
    script.duration?.trim() ||
    script.presenter?.trim() ||
    script.background?.trim() ||
    script.product?.trim()
  ) {
    lines.push("");
  }

  for (const scene of script.scenes) {
    lines.push(`Scene ${scene.sceneNumber} — ${scene.sceneName}`);
    lines.push(`  Seeing: ${scene.seeing}`);
    lines.push(`  Hearing: ${scene.hearing}`);
    if (scene.product) lines.push(`  Product: ${scene.product}`);
    if (scene.props) lines.push(`  Props: ${scene.props}`);
  }
  if (script.scenes.length > 0) lines.push("");

  if (script.script?.trim()) {
    lines.push(script.script.trim());
  }

  if (script.rationale?.trim()) {
    if (lines.at(-1) !== "") lines.push("");
    lines.push(`Rationale: ${script.rationale.trim()}`);
  }

  return lines.join("\n").trimEnd();
}
